import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';

import {initArticleReactionsAndComments} from '../../../modules/card-counters';
import {SLOTS_MAPPING} from '../../constants/ad-slots';
import {getFormattedDate, getTimeStamp} from '../../utils/date';
import {splitArrayIntoChunks} from '../../utils/helpers';
import AdSlot from '../ad-slot';
import {TrendCard} from '../trend-card';

import styles from './trend-articles-list.module.css';

const TrendArticlesList = ({isLoading, articles, getMoreArticles, withHeader = false, isCustom}) => {
  const {t, i18n} = useTranslation();

  useEffect(() => {
    if (articles.length > 0) {
      initArticleReactionsAndComments();
    }
  }, [articles.length]);

  const renderArticlesWithAds = () => {
    const articlesChunks = splitArrayIntoChunks(articles, 10);
    const articlesToRender = articlesChunks.map(chunk => chunk.map((article, index) => {
      const suffixForId = getTimeStamp(article.publishedAt);

      return (
        <React.Fragment key={article.url}>
          <div className={styles.trendCard} key={article.url}>
            <TrendCard
              date={article.publishedAt}
              formattedDate={getFormattedDate(article.publishedAt, i18n.language)}
              {...article}
            />
          </div>
          {(!isCustom && (index === 2 || index === 5 || index === 8)) || (index === 2)
            ? (
              <AdSlot
                className="rootWithBorderWithBigIndent"
                slotMapping={{
                  desktop: {
                    ...SLOTS_MAPPING.Desktop_Bottom,
                    code: `${SLOTS_MAPPING.Desktop_Bottom.code}-${suffixForId}`
                  },
                  smartphone: {
                    ...SLOTS_MAPPING.Mobile_Slot2,
                    code: `${SLOTS_MAPPING.Mobile_Slot2.code}-${suffixForId}`,
                    adfoxParams: {
                      ...SLOTS_MAPPING.Mobile_Slot2.adfoxParams,
                      containerId: `${SLOTS_MAPPING.Mobile_Slot2.adfoxParams.containerId}-${suffixForId}`
                    }
                  }
                }}
                key={`${SLOTS_MAPPING.Desktop_Bottom.code}-${suffixForId}`}
              />
            )
            : null
          }
        </React.Fragment>
      );
    }));

    return articlesToRender;
  };

  return (
    <>
      {withHeader && (
        <header className={clsx(styles.header, 'section-headline', 'section-headline--primary')}>
          <h2 className="section-headline__heading">{t('publications')}</h2>
        </header>
      )}
      {renderArticlesWithAds()}
      {articles.length >= 10 && (
        <button className={styles.button} onClick={getMoreArticles} disabled={isLoading}>{t('loadMore')}</button>
      )}
    </>
  );
};

export {TrendArticlesList};
